module.exports = __webpack_public_path__ + "static/media/contratolaboral.5a658d97.svg";